import { List, Map as ImmutableMap } from 'immutable';
import { FetchProfileOptionsActionTypes } from '../actions/ProfileOptionsActions';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap({
  languageOptions: List(),
  supportsSignature: false,
  supportsConnectedEmailAddresses: false
});
export default handleActions({
  [FetchProfileOptionsActionTypes.SUCCESS](state, action) {
    return state.merge(action.payload.data);
  }
}, initialState);